import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingApiService {

  endpoint = environment.endpoint;

  constructor(
    private http: HttpClient
  ) { }

  getAllPriceCampaign() {
    return firstValueFrom(this.http.get(`${this.endpoint}/price-campaign/all`));
  }

  updatePriceCampaign(id: string, body: { name: string }) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/price-campaign/update/${id}`, body));
  }

  getAllCampaignGroup() {
    return firstValueFrom(this.http.get(`${this.endpoint}/campaign-group/all`));
  }

  updateCampaignGroup(id: string, body: { name: string; note: string; color: string; priority?: number; }) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/campaign-group/update/${id}`, body));
  }

  createCampaignGroup(body: { name: string; note: string; color: string; priority: number; }) {
    return firstValueFrom(this.http.post(`${this.endpoint}/campaign-group/create`, body));
  }

  createPriceCampaign(body: { name: string; campaign_group_id: string; }) {
    return firstValueFrom(this.http.post(`${this.endpoint}/price-campaign/create`, body));
  }

  getWebConfig() {
    return firstValueFrom(this.http.get(`${this.endpoint}/web-config`));
  }

  updateWebConfig(body: {
    percentSetList?: number;
    percenTikTokSetList?: number;
    costPriceIndex?: number;
    srpPriceIndex?: number;
    percentPriceList?: number;
    tiktokCostPriceIndex?: number;
  }) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/web-config`, body));
  }

}
